import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/dictionary',
            name: 'dictionary',
            component: () => import("./views/dictionary.vue")
        },
    ];
};